import React,{useState,useEffect} from 'react'
import { useLocation } from "react-router-dom";
import { calculateExceptionDepreciation } from '../services/asset.service';
import  * as CryptoJS  from "crypto-js";
import ConfirmBox from './ConfirmBox';
function MultiListExceptionPopUp(props) {
    
    var block = props.show3? "display-block": "";
    const [validName, setValidName] = useState(true);
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [popupLoading, setPopupLoading] = useState(false);
    const [overwriteDep, setOverwriteDep] = useState('No');
    const [overwriteBtn, setOverwriteBtn] = useState(false);
    const [financeInfo3, setFinanceInfo3] = useState(false);
    const [listOptions3, setListData3] = useState([]);
    //const [listOptions3, setListData3] = useState([]);
    
    var exception_tags = [...props.exceptionData];
    //console.log('exception_tags='); console.log(exception_tags);
    const [foundAssets, setFoundAssets] = useState(exception_tags);
    
    const filter = (e) => {
        const keyword = e.target.value;
        if (keyword !== '') {
            const results = exception_tags.filter((asset) => {
            return asset.tag.startsWith(keyword);
        });
        setFoundAssets(results);
        } else {
        setFoundAssets(exception_tags);
        // If the text field is empty, show all users
        }
        setName(keyword);
    };
    const [back_url, setBackUrl] = useState(false);
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Finance = query.get('finance'); 
    //const elementRef = useRef();
    useEffect(() => {
        if(Finance!='' && Finance!=null){
            const decryptedBytes = CryptoJS.AES.decrypt(Finance.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
              // Convert the decrypted bytes to a string
              const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
              //const decryptedFinance = decrypt_data.finance;
              setBackUrl(decrypt_data?.back_url);
              setFinanceInfo3(decrypt_data);
          }
        //setListData3({listOptions3});
        //setFoundAssets(exception_tags);
        setListData3(listOptions3);
    }, []);
    // check array pushListOptions
    //refrest_ListData3
    const refrest_ListData3 = (e) => {
        setListData3(listOptions3);
    }
    const pushListOptions=(obj)=>{
        var flag=0;
        setPopupLoading('..');
        listOptions3.forEach((elem)=>{
          if(obj.value===elem.value && obj.label===elem.label){
            flag=1;
        }
      });
      setPopupLoading(false);
      if(flag===1){
          return false;
      }else{
          return true;
      }
    };

   //search filter 
   // the value of the search field 
  const [name, setName] = useState('');
   // the search result
  //const [foundAssets, setFoundAssets] = useState(exception_tags);
  //console.log('foundAssets='); console.log(foundAssets);
  
  //start validation   
  const handleSubmit = async (e) => { 
      e.preventDefault(); var valid_Name=true;
  if(financeInfo3.finance_year ===''){
        setValidName(false);
        alert("Financial year is missing"); valid_Name=false;
  }
  if(financeInfo3.finance_month ===''){ 
        setValidName(false);
        alert('Month is missing'); valid_Name=false;
  }
  if(listOptions3.length===0){ //alert(listOptions3.length);
        setValidName(false);
        alert('Please select atleast one Asset'); valid_Name=false;
  }
  if (!valid_Name) { //alert(valid_Name); 
          return false;
      }else{ //alert(mon); alert(fy);
          saveData();
      }
  }
  const handleOverwriteDep = async (e) => {
    e.preventDefault();
    const overwriteConfirmation = window.confirm("Are you sure you want to Overwrite?");
    //alert(overwriteConfirmation);
    if (overwriteConfirmation) {
        //alert("Confirmed! Proceeding...");
        //setOverwriteDep('Yes'); 
        saveData('Yes');
    } else {
        // User clicked "Cancel"
        return false;
    }
  }

  const saveData = async (overwrite='No') => {
    var obj = {
      //'tag': tag, 
      'owerwrite_dep': overwrite, 
      'session':financeInfo3.finance_year, 
      'month':financeInfo3.finance_month,
      'assets':listOptions3,
      'company_id':sessionStorage.getItem('LoggedInCompanyId'),
      'division_id':sessionStorage.getItem('LoggedInDivisionId'),
    }
    
    let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data':obj,
        'authToken': sessionStorage.getItem('LoggedInToken'),
    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
    let oData = {'token':EncryptData}
    try {  //setLoading('..'); // Set loading before sending API request
        calculateExceptionDepreciation(oData).then(function(res){
            //console.log(res);
            if(res.data.message.warning=="Already Exist"){
                setSuccess('');
                setErrMsg(' Depreciation Already Exist. Data: ' + res.data.message.tags.join(", ") );
                setOverwriteBtn(true);
            }else if(res.data.message.success=="Inserted"){
                setErrMsg('');
                setSuccess(' Successfully Genrated Depreciation. Data: '+ res.data.message.tags.join(", ") );
            }
            //elementRef.current.focus();
        }); setValidName(false);
        props.setLoading(false); // Stop loading
    } catch (err) { 
        setSuccess(false);
        //console.error(err);
        if (!err?.data1) {
            setErrMsg('No Server Response');
        } else if (err.data1?.status === 409) {
            setErrMsg('Record already exists');
        } else {
            setErrMsg('Insert/Update Failed');
        }
        props.setLoading(false); // Stop loading
        // //elementRef.current.focus();
    }
  }

    const handleMoveList1 = (e) => {
        const selectedOptions =[];
        //alert('dd');
        var Options3 = document.getElementById('exceptionListBox').options;
        //console.log(Options3);
        for (var i = 0, l = Options3.length; i < l; i++) {
            if (Options3[i].selected) {
                var option1 = {
                    label: Options3[i].label,
                    value: Options3[i].value,
                }
                if (pushListOptions(option1)) {
                    listOptions3.push(option1);
                }
            }
        } //setListData3(listOptions3); 
        setListData3((prevList) => prevList.filter((option) => !selectedOptions.find((selected) => selected.value === option.value)));
        
        //console.log('listOptions3');console.log(listOptions3);
    }
    const handleMoveList3 = (e) => {
        const selectedOptions3 =[];
        var options3 = document.getElementById('lstBox3').options;
        //console.log(Options3);
        for (var i = 0, l = options3.length; i < l; i++) {
            if (options3[i].selected) {
                var option1 = {
                    label: options3[i].label,
                    value: options3[i].value,
                }
                if (pushListOptions(option1)) {
                    listOptions3.push(option1);
                }
            }
        } //setListData3(listOptions3); 
        setListData3((prevList) => prevList.filter((option) => !selectedOptions3.find((selected) => selected.value === option.value)));
        
        //console.log('listOptions3');console.log(listOptions3);
    }
    const handleAllMoveList1 = (e) => { //alert('dd');
        //var listOptions = [];
        var Options3 = document.getElementById('exceptionListBox').options;
        for (var i = 0, l = Options3.length; i < l; i++) {
            var option1 = {
                label: Options3[i].label,
                value: Options3[i].value,
            }
            if (pushListOptions(option1)) {
                listOptions3.push(option1);
            }
            //listOptions3.push(option1);
        } //setListData3(listOptions3); console.log(listOptions3);
        setListData3(listOptions3);
    }
    const handleAllRemove = (e) => { //alert('dd');
        //var options3 = document.getElementById('exceptionListBox').options;
        //alert(options.length);
        setListData3([]); 
    }
    
    return (
        <div className={block +" custom-modal width-80 height-80"}>
        
        
        <div className="custom-close" > <span onClick={ ()=>{props.showsetter3(false)} } className="bi bi-x-circle-fill"></span> </div>
            <div className="title custom-modal-title">
                <h5>{props.title3}</h5> 
                
            </div>
            {success ? (
				<div className="alert alert-success" role="alert"><i className="bi bi-check-circle-fill"></i>{success}</div>
			        ) : ( errMsg ? (<div className="alert alert-danger" role="alert"><i className="bi bi-exclamation-triangle-fill"></i>{errMsg}</div>):('')
                ) }
            <div className="subject-info-box-1">
            <input  type="search"  value={name} onChange={filter} className="form-control" placeholder="Filter"
            />
            <select multiple="multiple" id='exceptionListBox' className="form-select form-select-sm">
            {foundAssets && foundAssets.length > 0 ? (
                foundAssets.map((option) => (
                <option value={option.tag}>{option.tag}</option>
                ))
            ) : (
            <h1>No results</h1>
            )}
            </select>
        </div>

        <div className="subject-info-arrows text-center">{popupLoading ? (<div className="spinner-border text-primary" role="status">
                              <span className="sr-only">{popupLoading}</span>
                            </div>) : ('') }
        <button onClick={filter} value=""  className="btn btn-info btn-sm refresh">Refresh</button><br /><br />
        <input type='button' id='btnAllRight' onClick={handleAllMoveList1} value='Add All' className="btn btn-default" /><br />
        <input type='button' id='btnRight' onClick={handleMoveList1} value='>' className="btn btn-default" /><br />
        
        <input type='button' id='btnAllLeft' onClick={handleAllRemove} value='Remove All' className="btn btn-default" />
        </div>
    
        <div className="subject-info-box-2">
        {/*<div className="subject-refresh">
        <button onClick={refrest_ListData3} value=""  className="form-control btn-info refresh">Refresh</button>
            </div>*/}
        <select multiple="multiple" id='lstBox3' className="form-select form-select-sm">
            {   listOptions3.map((option) => (
                <option value={option.value}>{option.label}</option>
                )) }
        </select>
        </div>

        <div className="clearfix"></div>
        {(overwriteBtn)?(<form name="" onSubmit={handleOverwriteDep}>
            <button onClick={ () =>{ //data.push();
                                    props.datasetter3(exception_tags);
                                    }
                            } 
            className="btn btn-info btn-md float-end"> Overwrite </button>
            
        </form>):(<form name="" onSubmit={handleSubmit}>
            <button onClick={ () =>{ //data.push();
                                    props.datasetter3(exception_tags);
                                    }
                            } 
            className="btn btn-primary btn-md float-end"> Genrate </button>
            
        </form>)
        }
        
    </div>
    )
}

export default MultiListExceptionPopUp